import { render, staticRenderFns } from "./SummaryModule.vue?vue&type=template&id=4c0ee17f&"
import script from "./SummaryModule.vue?vue&type=script&lang=js&"
export * from "./SummaryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports